import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Typography } from "@mui/material";
import { styles } from "./styles";
import { minorPlanFeatures } from "./helper";

export const MinorPlanDetails: React.FC<{ isYearly: boolean }> = ({
  isYearly,
}) => {
  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <Typography variant="h6">Free</Typography>
      </Box>

      {/* {isUpgradePlanAvailable && (
        <Button
          onClick={getCustomerPortalLink}
          sx={{ ...styles.button, width: "100%", margin: 0 }}
        >
          Upgrade
        </Button>
      )} */}

      <ul style={styles.minorPlanFeatureUl}>
        {minorPlanFeatures.map((feature, index) => (
          <li key={index} style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            {feature}
          </li>
        ))}
      </ul>
    </Box>
  );
};
